/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home': {
    width: 16,
    height: 16,
    viewBox: '0 0 53.87 52.19',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M53.52 26.16L26.93.69.35 26.16M6.11 27.34v20.55a3.81 3.81 0 0 0 3.81 3.81h12.17V38.12a1.63 1.63 0 0 1 1.63-1.63h6.38a1.63 1.63 0 0 1 1.63 1.63v13.57H44a3.81 3.81 0 0 0 3.81-3.81V27.34M44.53 13.65V8.84A3.81 3.81 0 0 0 40.72 5h-4.48"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/home.js